(function ($) {
  $(document).ready(function () {
    "use strict";

    // HIDE RECHARGE EMPTY
    var rechargeWidget = $('.product-info-container .recharge-subscription-widget');

        if (rechargeWidget.find(':empty').length) {
            rechargeWidget.hide();
        }

  // HAMBURGER
  $('.hamburger-menu').on('click', function (e) {
    $('.hamburger-menu .hamburger').toggleClass("active");
    $(".bars .bar").toggleClass("rotated");
    $(".side-hamburger-menu").toggleClass("active");
    $(".tn-header").toggleClass("active");
    $("body").toggleClass("overflow-hidden");

  });

  // TAB
  $('.tab-navigation li').click(function () {
    var tabId = $(this).index();
    var $tabsContainer = $(this).closest('.tab-wrapper');
    $(this).addClass('active').siblings().removeClass('active');
    $tabsContainer.find('.tab-content .tab-pane').eq(tabId).addClass('active').siblings().removeClass('active');
  });


  // ACCORDION
  $('.accordion-header').click(function () {
    $(this).toggleClass('open');
    $(this).siblings('.accordion-content').slideToggle();
    $(this).parent().siblings().find('.accordion-content').slideUp();
    $(this).parent().siblings().find('.accordion-header').removeClass('open');
  });


  // RECHARGE WRAP SPAN
  setTimeout(function() {
    $(".rc-radio__label").each(function () {
      const text = $(this).text();
      const newText = text.replace(/(\$[0-9.]+)/g, '<span>$1</span>');
      $(this).html(newText);
    });

    const secondLabel = $(".rc-radio.onetime-radio .rc-radio__label");
    const text = secondLabel.text();
    const newText = text.replace(/(\$[0-9.]+)/g, '<span>$1</span>');
    secondLabel.html(newText);
  }, 1000);



  // Wait for the Recharge app variable prices to appear
  // Wait for the Recharge app variable prices to appear
  function waitForRechargePrices() {
      const rechargePricesContainer = $('.rc-template__radio');

      if (rechargePricesContainer.length > 0) {
          // Recharge prices are available, proceed to update the regular price
          updateRegularPrice();
      } else {
          // Recharge prices are not available yet, wait and check again
          setTimeout(waitForRechargePrices, 100);
      }
  }

  // Function to update the regular price based on the selected radio input
  function updateRegularPrice() {
      // Get the default selected radio input
      const defaultSelectedOption = $('input[name="purchaseOption"]:checked');

      // Get the price value from the default selected radio input
      const defaultPriceValue = defaultSelectedOption.siblings('.rc-radio__label').find('span:last').text();

      // Add "AUD" to the default selected price and update the .price-item--regular
      $('.price-item--regular').text(defaultPriceValue + ' AUD');

      // Listen for changes in the radio input
      $('input[name="purchaseOption"]').on('change', function () {
          const selectedOption = $('input[name="purchaseOption"]:checked');
          if (selectedOption.length > 0) {
              // Get the price value from the selected radio input
              const priceValue = selectedOption.siblings('.rc-radio__label').find('span:last').text();

              // Add "AUD" to the price value and update the .price-item--regular
              $('.price-item--regular').text(priceValue + ' AUD');
          }
      });
  }

  // Start waiting for Recharge prices
  waitForRechargePrices();



  // LOGIN - FORGET PASSWORD
  $(".lost-password-form").hide();
  $(".forget-password-link").click(function () {
    $(".login-form").hide();
    $(".lost-password-form").show();
  });

  $(".cancel-link").click(function () {
    $(".login-form").show();
    $(".lost-password-form").hide();
  });


});
// END DOCUMENT READY



// REDIRECT
const urlPath = window.location.pathname;

if (
     urlPath === "/products"
  || urlPath === "/products/"
  || urlPath === ("/collections")
  || urlPath === ("/collections/")
  || urlPath === "/collections/all"
  || urlPath === "/collections/all/"
  || urlPath === "/collections/frontpage"
  || urlPath === "/collections/frontpage/"
) {
  window.location.href = "/products/tribiotic-gut-shield";
}


/* PRODUCT SLIDER */
const product_thumbs_slider = new Swiper(".product-thumbs-slider-wrapper .product-thumbs-slider", {
  slidesPerView: 3,
  spaceBetween: 10,
  loop: true,
  speed: 600,
  on: {
    init: function () {
      updateExtraSlides(this);
    },
    resize: function () {
      updateExtraSlides(this);
    },
    slideChange: function () {
      updateExtraSlides(this);
    },
  },
});

const product_image_slider = new Swiper(".product-images .product-image-slider", {
  loop: true,
  speed: 600,
  thumbs: {
    swiper: product_thumbs_slider,
  },
});

function updateExtraSlides(swiperInstance) {
  const totalSlides = swiperInstance.slides.length;
  const visibleSlides = Math.min(swiperInstance.params.slidesPerView, totalSlides);
  const extraSlides = totalSlides - visibleSlides;
  const extraSlidesElement = document.querySelector(".product-thumbs-slider-wrapper .extra-slides span");

  if (extraSlides > 0) {
    extraSlidesElement.style.display = "block";
    extraSlidesElement.textContent = `+${extraSlides}`;
  } else {
    extraSlidesElement.style.display = "none";
  }
}


// INIT SCROLLTRIGGER
gsap.registerPlugin(ScrollTrigger);



// DR ROSS WALKER
if ($(".tn-side-tab-content-mobile")[0]) {
  const textEffects = document.querySelectorAll(".tn-side-tab-content-mobile .accordion");

  textEffects.forEach((textEffect) => {
    const splitText = new SplitText(textEffect.querySelectorAll("h2, h5, p, .tn-side-tab-content-mobile .accordion .accordion-item .accordion-header"), {
      type: "lines",
      linesClass: "split-text-line",
    });

    const splitLines = splitText.lines;
    const linkWithText = textEffect.querySelector("a");


    if (linkWithText) {
    gsap.set(linkWithText, {
      opacity: 0,
      y: 100
    });
    }


    gsap.set(splitLines, {
      opacity: 0,
      rotationX: -50,
      rotation: 10
    });

    ScrollTrigger.create({
      trigger: textEffect,
      start: "top 80%",
      scrub: true,
      onEnter: () => {
        gsap.to(splitLines, {
          duration: 0.75,
          ease: "circ.out",
          opacity: 1,
          rotationX: 0,
          rotation: 0,
          force3D: true,
          transformOrigin: "top left -100",
          delay: 0.4,
          stagger: {
            start: "50% 60%",
            each: 0.05,
          },
        });

        if (linkWithText) {
          gsap.to(linkWithText, {
            duration: 0.75,
            ease: "circ.out",
            delay: 0.6,
            opacity: 1,
            y: 0,
          });
        }
      },
      once: true,
    });
  });
}




// DR ROSS WALKER
document.addEventListener('DOMContentLoaded', function () {
  const initTextEffects = () => {
    const textEffects = document.querySelectorAll(".tn-dr-ross-walker .col");

    textEffects.forEach((textEffect) => {
      const splitText = new SplitText(textEffect.querySelectorAll("h2, h5, p, .accordion-header"), {
        type: "lines",
        linesClass: "split-text-line",
      });

      const splitLines = splitText.lines;

      if (splitLines.length > 0) {
        splitLines.forEach((line) => {
          gsap.set(line, {
            opacity: 0,
            rotationX: -50,
            rotation: 10,
          });
        });

        ScrollTrigger.create({
          trigger: textEffect,
          start: "top 80%",
          scrub: true,
          onEnter: () => {
            gsap.to(splitLines, {
              duration: 0.75,
              ease: "circ.out",
              opacity: 1,
              rotationX: 0,
              rotation: 0,
              force3D: true,
              transformOrigin: "top left -100",
              delay: 0.4,
              stagger: {
                start: "50% 60%",
                each: 0.05,
              },
            });
          },
          once: true,
        });
      }
    });
  };

  if ($(".tn-dr-ross-walker")[0]) {
    initTextEffects();
  }
});



// DR ROSS WALKER ACCORDION
if ($(".tn-dr-ross-walker .accordion")[0]) {
  gsap.set(".tn-dr-ross-walker .accordion-item", { opacity: 0 });

  ScrollTrigger.create({
    trigger: ".tn-dr-ross-walker .accordion",
    start: "top 80%",
    onEnter: () => {
      gsap.to(".tn-dr-ross-walker .accordion-item", {
        duration: 0.5,
        opacity: 1,
        stagger: 0.2,
        ease: "power2.inOut",
      });
    },
    once: true,
  });
}

// DR ROSS WALKER FIGURE
if ($(".tn-dr-ross-walker figure")[0]) {
  gsap.set(".tn-dr-ross-walker figure", { opacity: 0 });

  ScrollTrigger.create({
    trigger: ".tn-dr-ross-walker figure",
    start: "top 80%",
    onEnter: () => {
      gsap.to(".tn-dr-ross-walker figure", {
        duration: 0.5,
        opacity: 1,
        ease: "power2.inOut",
      });
    },
    once: true,
  });
}






// TEXT EFFECT
if (document.querySelector(".text-effect")) {
  const textEffects = document.querySelectorAll(".text-effect");

  textEffects.forEach((textEffect) => {
    const textElements = textEffect.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li");

    const splitText = new SplitText(textElements, {
      type: "lines",
      linesClass: "split-text-line",
    });

    const splitLines = splitText.lines;
    const linkWithText = textEffect.querySelector("a");

    gsap.set(splitLines, {
      opacity: 0,
      rotationX: -50,
      rotation: 10
    });
    if (linkWithText) {
      gsap.set(linkWithText, {
        opacity: 0,
        y: 100
      });
    }

    const revertSplitText = () => {
      splitText.revert();
    };

    ScrollTrigger.create({
      trigger: textEffect,
      start: "top 80%",
      scrub: true,
      onEnter: () => {
        gsap.to(splitLines, {
          duration: 0.75,
          ease: "circ.out",
          opacity: 1,
          rotationX: 0,
          rotation: 0,
          force3D: true,
          transformOrigin: "top left -100",
          delay: 0.4,
          stagger: {
            start: "50% 60%",
            each: 0.05,
          },          
          onComplete: revertSplitText
        });

        if (linkWithText) {
          gsap.to(linkWithText, {
            duration: 0.75,
            ease: "circ.out",
            delay: 0.6,
            opacity: 1,
            y: 0,
          });
        }
      },
      once: true,
    });
  });
}






// MARQUEE
if ($(".tn-marquee-text")[0]) {
  let direction = 1;
  const roll1 = roll(".rollingText", {
      duration: 20
    }),
    roll2 = roll(".rollingText02", {
      duration: 20
    }, true),
    scroll = ScrollTrigger.create({
      onUpdate(self) {
        if (self.direction !== direction) {
          direction *= -1;
          gsap.to([roll1, roll2], {
            timeScale: direction,
            overwrite: true
          });
        }
      }
    });

  function roll(targets, vars, reverse) {
    const tl = gsap.timeline({
      repeat: -1,
      onReverseComplete() {
        if (!tl.reversing) { // Check if reverse is not already in progress
          tl.reversing = true;
          this.totalTime(this.rawTime() + this.duration() * 10);
          tl.reversing = false;
        }
      }
    });
    vars = vars || {};
    vars.ease || (vars.ease = "none");
    gsap.utils.toArray(targets).forEach(el => {
      let clone = el.cloneNode(true);
      el.parentNode.appendChild(clone);
      gsap.set(clone, {
        position: "absolute",
        top: el.offsetTop,
        left: el.offsetLeft + (reverse ? -el.offsetWidth : el.offsetWidth)
      });
      tl.to([el, clone], {
        xPercent: reverse ? 100 : -100,
        ...vars
      }, 0);
    });
    return tl;
  }
}



// HERO TEXT
if ($(".tn-hero")[0]) {
  const splitText = new SplitText(".tn-hero h1", {
    type: "lines",
    linesClass: "split-text-line",
  });

  const splitLines = splitText.lines;

  gsap.set(splitLines, {
    opacity: 0,
    rotationX: -50,
    rotation: 10,
  });

  const h1Timeline = gsap.timeline({
    paused: true,
  });

  h1Timeline.to(splitLines, {
    duration: 0.75,
    ease: "circ.out",
    opacity: 1,
    rotationX: 0,
    rotation: 0,
    force3D: true,
    transformOrigin: "top left -100",
    delay: 0.4,
    stagger: {
      start: "50% 60%",
      each: 0.05,
    },
  });

  ScrollTrigger.create({
    trigger: ".tn-hero",
    start: "top 80%",
    onEnter: () => h1Timeline.play(),
    onLeaveBack: () => h1Timeline.reverse(),
    once: true,
  });

  gsap.set(".tn-hero .tn-button-ghost", {
    y: 100,
  });

  const buttonTimeline = gsap.timeline({
    paused: true,
  });

  buttonTimeline.to(".tn-hero .tn-button-ghost", {
    duration: 0.3,
    delay:0.5,
    opacity: 1,
    y: 0,
  });

  ScrollTrigger.create({
    trigger: ".tn-hero",
    start: "top 80%",
    onEnter: () => buttonTimeline.play(),
    onLeaveBack: () => buttonTimeline.reverse(),
    once: true,
  });
}



// DASHED CIRCLE
if ($(".dashed-circle-lines")[0]) {
  const rotate = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.tn-side-text',
        scrub: 1,
        start: 'top center',
        end: 'bottom top',
      },
    })
    .to('.dashed-circle-lines svg', {
      rotation: () => 180,
      duration: 10,
      ease: 'none',
    });
}





// SIDE TAB CONTENT
if ($(".tn-side-tab-content")[0]) {
  const tabItems = document.querySelectorAll(".tn-side-tab-content .tab-navigation li");
  gsap.set(tabItems, {
    y: 350,
    opacity: 0
  });
  ScrollTrigger.create({
    trigger: '.tn-side-tab-content',
    start: "top 50%",
    onEnter: () => {
      gsap.to(tabItems, {
        duration: 0.75,
        ease: "circ.out",
        opacity: 1,
        y: 0,
        stagger: 0.15,
      });
    }
  });
}


// SIDE TAB CONTENT ANIM
if ($(".tn-side-tab-content")[0]) {
  const tabEffects = document.querySelectorAll(".tn-side-tab-content .tab-pane.active");

  tabEffects.forEach((textEffect) => {
    const splitText = new SplitText(textEffect.querySelectorAll("h2, h3, h6, p"), {
      type: "lines",
      linesClass: "split-text-line",
    });

    const splitLines = splitText.lines;
    const linkWithText = textEffect.querySelector("a");

    gsap.set(splitLines, {
      opacity: 0,
      rotationX: -50,
      rotation: 10
    });
    gsap.set(linkWithText, {
      opacity: 0,
      y: 100
    });

    ScrollTrigger.create({
      trigger: textEffect,
      start: "top 80%",
      scrub: true,
      onEnter: () => {
        gsap.to(splitLines, {
          duration: 0.75,
          ease: "circ.out",
          opacity: 1,
          rotationX: 0,
          rotation: 0,
          force3D: true,
          transformOrigin: "top left -100",
          delay: 0.4,
          stagger: {
            start: "50% 60%",
            each: 0.05,
          },
        });

        gsap.to(linkWithText, {
          duration: 0.75,
          ease: "circ.out",
          delay: 0.6,
          opacity: 1,
          y: 0,
        });
      },
      once: true,
    });
  });
}


// SIDE TAB CONTENT LINK ANIM
if ($(".tn-side-tab-content")[0]) {
  function animateTabContent(tabContent) {
    const splitText = new SplitText(tabContent.querySelectorAll("h2, h3, h6, p"), {
      type: "lines",
      linesClass: "split-text-line",
    });

    const splitLines = splitText.lines;
    const linkWithText = tabContent.querySelector("a");

    gsap.set(splitLines, {
      opacity: 0,
      rotationX: -50,
      rotation: 10
    });
    gsap.set(linkWithText, {
      opacity: 0,
      y: 100
    });

    ScrollTrigger.create({
      trigger: tabContent,
      start: "top 80%",
      scrub: true,
      onEnter: () => {
        gsap.to(splitLines, {
          duration: 0.75,
          ease: "circ.out",
          opacity: 1,
          rotationX: 0,
          rotation: 0,
          force3D: true,
          transformOrigin: "top left -100",
          delay: 0.4,
          stagger: {
            start: "50% 60%",
            each: 0.05,
          },
        });
        gsap.to(linkWithText, {
          duration: 0.75,
          ease: "circ.out",
          delay: 0.6,
          opacity: 1,
          y: 0,
        });
      },
      once: true,
    });
  }

  $('.tn-side-tab-content .tab-navigation li').click(function () {
    var tabId = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $('.tn-side-tab-content .tab-content .tab-pane').eq(tabId).addClass('active').siblings().removeClass('active');
    const activeTabContent = $('.tab-content .tab-pane.active')[0];
    animateTabContent(activeTabContent);
  });
}









// PRODUCTS FEATURES TAB
if ($(".tn-product-features-tab")[0]) {
  const tabItems = document.querySelectorAll(".tn-product-features-tab .tab-navigation li");
  gsap.set(tabItems, {
    y: 350,
    opacity: 0
  });
  ScrollTrigger.create({
    trigger: '.tn-product-features-tab',
    start: "top 50%",
    onEnter: () => {
      gsap.to(tabItems, {
        duration: 0.75,
        ease: "circ.out",
        opacity: 1,
        y: 0,
        stagger: 0.15,
      });
    }
  });
}


// PRODUCTS FEATURES TAB ANIM
if ($(".tn-product-features-tab")[0]) {
  const tabEffects = document.querySelectorAll(".tn-product-features-tab .tab-pane.active");

  tabEffects.forEach((textEffect) => {
    const splitText = new SplitText(textEffect.querySelectorAll("h2, h3, h6, p"), {
      type: "lines",
      linesClass: "split-text-line",
    });

    const tabImage = document.querySelectorAll(".tn-product-features-tab .features-tab .tab-content .tab-pane .content figure");

    const splitLines = splitText.lines;

    gsap.set(splitLines, {
      opacity: 0,
      rotationX: -50,
      rotation: 10
    });


    ScrollTrigger.create({
      trigger: textEffect,
      start: "top 80%",
      scrub: true,
      onEnter: () => {
        gsap.to(splitLines, {
          duration: 0.75,
          ease: "circ.out",
          opacity: 1,
          rotationX: 0,
          rotation: 0,
          force3D: true,
          transformOrigin: "top left -100",
          delay: 0.4,
          stagger: {
            start: "50% 60%",
            each: 0.05,
          },
        });

        gsap.to(tabImage, {
          duration: 0.75,
          ease: "circ.out",
          delay: 0.6,
          opacity: 1,
        });
      },
      once: true,
    });
  });
}







// FEATURES TAB LINK ANIM
if ($(".features-tab")[0]) {
  function animateTabContent(tabContent) {
    const splitText = new SplitText(tabContent.querySelectorAll(".description p"), {
      type: "lines",
      linesClass: "split-text-line",
    });

    const splitLines = splitText.lines;
    const linkWithText = tabContent.querySelector("figure img");

    gsap.set(splitLines, {
      opacity: 0,
      rotationX: -50,
      rotation: 10,
    });
    gsap.set(linkWithText, {
      opacity: 0,
      y: 100,
    });

    gsap.to(splitLines, {
      duration: 0.75,
      ease: "circ.out",
      opacity: 1,
      rotationX: 0,
      rotation: 0,
      force3D: true,
      transformOrigin: "top left -100",
      delay: 0.4,
      stagger: {
        start: "50% 60%",
        each: 0.05,
      },
    });
    gsap.to(linkWithText, {
      duration: 0.75,
      ease: "circ.out",
      delay: 0.6,
      opacity: 1,
      y: 0,
    });
  }

  $('.features-tab .tab-navigation li').click(function () {
    var tabId = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $('.features-tab .tab-content .tab-pane').eq(tabId).addClass('active').siblings().removeClass('active');
    const activeTabContent = $('.tab-content .tab-pane.active .content')[0];
    animateTabContent(activeTabContent);
  });
}


// MILESTONES PIN
if ($(".tn-milestones")[0]) {
  gsap.from(".tn-milestones", {
    transformOrigin: "top center",
    scale: 0.90,
    ease: "none",
    borderRadius: "50",
    scrollTrigger: {
      trigger: ".tn-miles-stones-wrapper",
      start: "top top",
      end: "+=100%",
      scrub: true,
      //pin: true,
      anticipatePin: 1
    }
  });
}


// MILESTONES BG
if ($(".tn-milestones")[0]) {
  gsap.from(".tn-milestones .bg-image", {
    scale: 1.2,
    ease: "none",
    scrollTrigger: {
      trigger: ".tn-miles-stones-wrapper",
      start: "top top",
      end: "+=100%",
      scrub: true,
      //pin: true,
      anticipatePin: 1
    }
  });
}


// MILESTONES COLS + ODOMETER
if ($(".tn-milestones")[0]) {
  ScrollTrigger.create({
    trigger: ".tn-miles-stones-wrapper",
    start: "top top",
    onEnter: () => {
      gsap.to([".col-left", ".col-right"], {
        opacity: 1,
        duration: 1,
        delay: 0.6,
      });
      setTimeout(() => {
        $('.odometer').each(function () {
          var parent_section_postion = $(this).closest('.tn-miles-stones-wrapper').position();
          var parent_section_top = parent_section_postion.top;
          if ($(document).scrollTop() > parent_section_top) {
            if ($(this).data('status') == 'yes') {
              $(this).html($(this).data('count'));
              $(this).data('status', 'no');
            }
          }
        });
      }, 500);
    },
  });
}


// FOOTER TEXT EFFECT
const tl = gsap.timeline();
const splitText = new SplitText(".tn-footer .brand-text h2", {
  type: "chars"
});

tl.from(splitText.chars, {
  opacity: 0,
  duration: 1.2,
  delay: 0.6,
  stagger: 0.05,
  ease: "power2.out",
  onStart: () => {
    gsap.set(splitText.chars, {
      visibility: "visible"
    });
  },
});

ScrollTrigger.create({
  trigger: ".tn-footer .brand-text h2",
  start: 'top 80%'
});





// PILL DASHED CIRCLE DARK
if ($(".svg-wrapper")[0]) {
  const rotate = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.svg-wrapper',
        scrub: 1,
        start: 'top center',
        end: "+=" + 1200,
      },
    })
    .to('.svg-wrapper .dashed-circle', {
      rotation: () => 180,
      duration: 10,
      ease: 'none',
    });
}










// PILL TEXT
if ($(".tn-pill-benefit")[0]) {
gsap.set('.tn-pill-benefit .text-wrapper', { autoAlpha: 0 });

ScrollTrigger.create({
  trigger: ".tn-pill-benefit",
  start: "center center",
  end: "+=1200px",
  pin: true,
})


const pill_anim = gsap.timeline({
  scrollTrigger: {
    trigger: '.tn-pill-benefit',
    start: "center center",
    end: "+=400px",
    scrub: true
  }
});

pill_anim.to('.tn-pill-benefit .page-width .svg-wrapper .pill-wrapper img:nth-child(1)', {
  opacity: 1,
  duration: 1,
})
.to('.tn-pill-benefit .page-width .svg-wrapper .pill-wrapper img:nth-child(2)', {
  y: 0,
  duration: 1,
}, 0)
.to('.tn-pill-benefit .page-width .svg-wrapper .pill-wrapper img:nth-child(3)', {
  y: 0,
  duration: 1,
}, 0);


const stepsTimeline = gsap.timeline({
  scrollTrigger: {
    trigger: '.tn-pill-benefit',
    start: "top center",
    end: "+=1200px",
    scrub: true
  }
});


const steps = gsap.utils.toArray(".tn-pill-benefit .text-wrapper");


steps.forEach((step, i) => {
  stepsTimeline.add(() => {

    const forward = stepsTimeline.scrollTrigger.direction > 0,
          inEl = forward ? step : steps[i - 1],
          outEl = forward ? steps[i - 1] : step;
    outEl && gsap.to(outEl, {autoAlpha: 0, duration: 0.3, overwrite: true});
    inEl && gsap.to(inEl, {autoAlpha: 1, duration: 0.3, delay: 0.3, overwrite: true});
  }, i || 0.001);
});

stepsTimeline.to({}, {duration: 1})

}



// LIFESTYLE IMAGES
if ($(".tn-lifestyle-images")[0]) {
let lifestyle_images = document.querySelector(".tn-lifestyle-images .tn-row");
let scrollSpeed = window.innerWidth < 768 ? 3 : 1;

gsap.to(lifestyle_images, {
  x: () => -(lifestyle_images.scrollWidth - document.documentElement.clientWidth) + "px",
  ease: "none",
  scrollTrigger: {
    trigger: '.tn-lifestyle-images',
    invalidateOnRefresh: true,
    pin: true,
    scrub: scrollSpeed,
    start: "center center",
    end: () => "+=" + lifestyle_images.offsetWidth,
  },
});
}




// STICKY IMAGE CONTENT PARALLAX
const stickyImageContentSections = document.querySelectorAll(".tn-sticky-image-content");
stickyImageContentSections.forEach((section) => {
  const sideImage = section.querySelector(".tn-sticky-image-content .side-image-wrapper .side-image");
  gsap.to(sideImage, {
    yPercent: 40,
    ease: "none",
    scrollTrigger: {
      trigger: section,
      scrub: true,
    },
  });
});


// SIDE IMAGE CONTENT PARALLAX
const sideImageContentSections = document.querySelectorAll(".tn-side-image-content.image_content");
sideImageContentSections.forEach((section) => {
  const sideImage = section.querySelector(".side-image-wrapper .side-image");
  gsap.to(sideImage, {
    yPercent: 40,
    ease: "none",
    scrollTrigger: {
      trigger: section,
      scrub: true,
    },
  });
});


// SIDE CONTENT IMAGE PARALLAX
const sideContentImageSections = document.querySelectorAll(".tn-side-image-content.content_image");
sideContentImageSections.forEach((section) => {
  const sideImage = section.querySelector(".side-image-wrapper .side-image");
  gsap.to(sideImage, {
    yPercent: 40,
    ease: "none",
    scrollTrigger: {
      trigger: section,
      scrub: true,
    },
  });
});


// ICON LIST
if ($(".tn-icons-list")[0]) {
  ScrollTrigger.batch(".tn-icons-list .page-width .col", {
    onEnter: batch => gsap.to(batch, {
      duration: 1.8,
      autoAlpha: 1,
      stagger: 0.1
    }),
    start: 'top 80%'
  });
}


// APP LIQUID
if ($(".tn-apps")[0]) {
  ScrollTrigger.batch(".tn-apps h2", {
    onEnter: batch => gsap.to(batch, {
      duration: 1,
      autoAlpha: 1,
    }),
    start: 'top 80%'
  });
}


// REVIEW
if ($(".tn-reviews")[0]) {
  ScrollTrigger.batch(".tn-reviews h2", {
    onEnter: batch => gsap.to(batch, {
      duration: 1,
      autoAlpha: 1,
    }),
    start: 'top 80%'
  });
  ScrollTrigger.batch(".tn-reviews .col", {
    onEnter: batch => gsap.to(batch, {
      duration: 0.6,
      autoAlpha: 1,
      y:0,
      stagger: 0.3
    }),
    start: 'top 80%'
  });
}


// ACCORDION
if ($(".tn-accordion")[0]) {
  ScrollTrigger.batch(".tn-accordion .accordion .accordion-item", {
    onEnter: batch => gsap.to(batch, {
      duration: 1.8,
      autoAlpha: 1,
      stagger: 0.1
    }),
    start: 'top 80%'
  });
}


// TAB IMAGE TOOLTIP
$('.tab-navigation li').mouseenter(function (e) {
  const tooltip = $(this).find(".tooltip");
  const x = e.pageX - $(this).offset().left;
  const y = e.pageY - $(this).offset().top;
  $(this).css('z-index', '15');
  tooltip.css({
    'top': y + 50,
    'left': x + 50,
    'opacity': '1'
  });

}).mousemove(function (e) {
  const tooltip = $(this).find(".tooltip");
  const x = e.pageX - $(this).offset().left;
  const y = e.pageY - $(this).offset().top;
  tooltip.css({
    'top': y + -150,
    'left': x + 40
  });

}).mouseleave(function () {
  const tooltip = $(this).find(".tooltip");
  $(this).css('z-index', '15');
  tooltip.css({
    "opacity": "0"
  });
});



})(jQuery);

// HERO IMAGES
document.addEventListener("DOMContentLoaded", function() {

    if (document.querySelector(".tn-hero")) {
      const heroImages = document.querySelectorAll(".tn-hero .hero-image");

      heroImages.forEach((image, index) => {
        setTimeout(() => {
          image.style.transition = "opacity 1s ease-in-out";
          image.style.opacity = 1;
        }, index * 200); // stagger effect (200ms delay between images)
      });
    }

});
